import { useNavigate } from "react-router-dom";

import TopMenu from "components/UI/TopMenu";
import { routes } from "routes";

import "../styles.scss";

export enum TabName {
  Following,
  Followers,
}

interface IProps {
  tab: TabName;
}

const TOPICS = [
  "Following",
  "Followers",
];

export const Tabs = (props: IProps) => {
  const navigate = useNavigate();

  const tab = props.tab === TabName.Following ? "Following" : "Followers";

  const handleChange = (value: string) => {
    if (value === "Following") {
      navigate(routes.following());
    } else if (value === "Followers") {
      navigate(routes.followers());
    }
  };

  return (
    <div className="SubscribersPage-Tabs">
      <TopMenu
        topicValues={TOPICS}
        currentTopic={tab}
        setCurrentTopic={handleChange}
      />
    </div>
  );
};
